import * as theme from "./FormTitle.css";

const FormTitle = (props: FormTitleProps) => {
    const { title, styling } = props;
    return (
        <h1 style={styling} className={theme.cardTitle}>
            {title}
        </h1>
    );
};

interface FormTitleProps {
    title: string;
    styling?: object;
}

export { FormTitle };
export type { FormTitleProps };
